/**
 * 상수
 */
export const AUTH_SERVICE = {
  APP_MODE: {
    BASIC: "basic",
    PLUS: "plus",
    ANY: "any",
  },
  ACTIVATED: "activated",
  CREATED: "created",
  BOUGHT: "bought",
  CERT_DURATION_TYPE_LIST: ["activated", "created", "bought"],
};
